export const loadGMScript = (url: string) => {
  // TODO - Use load script from utag script ts
  if (!document.getElementById('gm-script')) {
    const script = document.createElement('script')
    script.type = 'text/javascript'

    script.src = url
    script.id = 'gm-script'
    document.getElementsByTagName('head')[0].appendChild(script)
  }
}
